import {ChangeDetectionStrategy, Component} from '@angular/core';
import {NotificationPage} from "../../services/notification/multi-page-notification/multi-page-notification.component";
import {ExternalCode} from "homey-housing-lottery-app-dto";
import {
  NotificationDialogContentComponent
} from "../../services/notification/notification-dialog-content/notification-dialog-content.component";

@Component({
  selector: 'homey-three-for-three-dialog',
  imports: [
    NotificationDialogContentComponent
  ],
  templateUrl: './three-for-three-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThreeForThreeDialogComponent extends NotificationPage<
  ExternalCode
> {

}
